
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-filter",
  components: {},
})
export default class IconFilter extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
